import React from "react";
import { FaSearch, FaSync } from "react-icons/fa";

/**
 * BARRE DE RECHERCHE - Gère la recherche et la réinitialisation
 * @param {Object} props
 * @param {string} props.searchTerm - Terme de recherche
 * @param {Function} props.onSearchChange - Callback changement recherche
 * @param {Function} props.onReset - Callback réinitialisation
 */
const DomainSearch = ({ searchTerm, onSearchChange, onReset }) => {
  return (
    <div className="row mb-4">
      <div className="col-md-6">
        <div className="input-group shadow-sm">
          <span className="input-group-text bg-white border-end-0">
            <FaSearch className="text-muted" />
          </span>
          <input
            type="text"
            className="form-control border-start-0 ps-0"
            placeholder="Rechercher un domaine..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchTerm && (
            <button
              className="btn btn-outline-secondary border-start-0"
              type="button"
              onClick={() => onSearchChange('')}
            >
              ×
            </button>
          )}
        </div>
      </div>
      
      <div className="col-md-6 d-flex align-items-center">
        <button
          className="btn btn-outline-primary d-flex align-items-center ms-auto"
          onClick={onReset}
        >
          <FaSync className="me-2" />
          Réinitialiser
        </button>
      </div>
    </div>
  );
};

export default DomainSearch;